var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"transform":"scale(1.3)"},on:{"click":_vm.changeThemeColor}},[_c('svg-icon',{attrs:{"class-name":"theme-icon","icon-class":"theme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }